import ObjStoryParser from "/lib/html5-software-library/src/ranj/eng/story/framework/serialization/ObjStoryParser";

/**
* StoryFactory.js
* 
* Created on 2-okt-2013, 16:51:34
*
* @author Ivo Swartjes for Ranj
**/
export default class NGTStoryFactory {

    constructor(assetLibrary, languagePack) {
        this.assetLibrary = assetLibrary;
        this.languagePack = languagePack;

        this.storyCache = {};
        this.storyParser = new ObjStoryParser(this.languagePack);
    }

    getStory(storyID) {
        var story = this.storyCache[storyID];
        if (story)
            return story;

        var jsonStr = this.assetLibrary.getAsset(storyID);
        if (!jsonStr)
            return null;

        var jsonObj;
        if (typeof jsonStr === ' string') {
            jsonObj = JSON.parse(jsonStr);
        } else {
            // Already parsed by PreloadJS
            jsonObj = jsonStr;
        }

        story = this.storyParser.parseStory(jsonObj);
        if (!story)
            return null;

        this.storyCache[storyID] = story;

        return story;
    }
}


